import { useState, useEffect } from 'react'

import classnames from 'classnames'
import DismissibleBanner from 'components/DismissibleBanner'
// eslint-disable-next-line import/no-extraneous-dependencies
import { Button } from 'baby-design'
import { useWindowSize } from 'usehooks-ts'
import { BREAKPOINT_MOBILE } from 'src/constants'
import FadeOut from '../../../../../../components/transitions/FadeOut'
import { SignUpBannerTreatmentProps } from './types'

import SignUpBannerCss from './SignUpBanner.styles.scss'

const SignUpBannerT1 = ({
  scrolled,
  previouslyDismissed,
  onDismissal,
  onClick,
  onDisplay,
  ctaPath,
}: SignUpBannerTreatmentProps) => {
  const [shown, setIsShown] = useState(false)

  const isMobile = useWindowSize().width < BREAKPOINT_MOBILE

  useEffect(() => {
    if (scrolled && !previouslyDismissed) {
      setIsShown(true)
      onDisplay()
    }
  }, [scrolled, previouslyDismissed, onDisplay])

  const closeBanner = () => {
    setIsShown(false)
    onDismissal()
  }

  return (
    <FadeOut
      animateOnEnter
      className={classnames(SignUpBannerCss.root, SignUpBannerCss.sticky)}
      show={shown}
    >
      <DismissibleBanner
        className={classnames(
          SignUpBannerCss.signUpBannerBg,
          SignUpBannerCss.T1
        )}
        role="banner"
        onClose={closeBanner}
      >
        <div className={SignUpBannerCss.t1Wrapper}>
          <p className={SignUpBannerCss.t1Copy}>
            <strong>Start building your registry!</strong>
            Add anything from any store, plus, get expert advice, track your
            pregnancy&nbsp;and&nbsp;more.
          </p>
          <Button
            href={`${ctaPath}?loc=Banner+Button+T1`}
            size={isMobile ? 'sm' : 'md'}
            variant="primary"
            onClick={() => onClick('Start my registry')}
          >
            Start&nbsp;my&nbsp;registry
          </Button>
        </div>
      </DismissibleBanner>
    </FadeOut>
  )
}

export default SignUpBannerT1
